module.exports = __webpack_public_path__ + "assets/img/modal-avatar-44bd406d.png";